/**
 * 字符串哈希压缩
 */
export const hashString = (str: string): string => {
  let hash = 0;
  if (str.length === 0) return hash.toString(36);
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // 转换为32位整数
  }
  return Math.abs(hash).toString(36);
};
